import React from "react";
import {
    List,
    Edit,
    Create,
    Datagrid,
    TextField,
    FunctionField,
    EditButton,
    SimpleForm,
    TextInput,
    ReferenceInput,
    SelectInput,
    required,
    Pagination,
} from "react-admin";
import { deleteEmptyKeys } from "../../helpers/deleteEmptyKeys";

import JsonEditor from "../core/JsonEditor";
import { LVEditToolbar, LVCreateToolbar } from "../core/toolbars";

/*
    To configure pagination - we should have a look at this
    https://github.com/marmelab/react-admin/blob/master/docs/List.md#pagination
*/

export const ChartSeriesList = (props) => {
    const ListPagination = (props) => <Pagination rowsPerPageOptions={[10, 25, 50, 100]} {...props} />;
    return (
        <List
            pagination={<ListPagination />}
            perPage={100}
            sort={{ field: "Subchart.subchart_order", order: "ASC" }}
            {...props}
        >
            <Datagrid>
                <TextField source="id" />
                <TextField source="name" />
                <FunctionField
                    label="Subchart"
                    source="subchartId"
                    render={(record) => record.Subchart && `${record.Subchart.order}: ${record.Subchart.name}`}
                    sortBy="Subchart.subchart_order"
                />
                <EditButton />
            </Datagrid>
        </List>
    );
};

const SeriesTitle = ({ record }) => <span>Series {record ? `"${record.name}"` : ""}</span>;

export const ChartSeriesEdit = (props) => (
    <Edit title={<SeriesTitle />} {...props} transform={deleteEmptyKeys("config")}>
        <SimpleForm toolbar={<LVEditToolbar redirect="list" />}>
            <TextInput source="name" validate={[required()]} />
            <TextInput source="alias" validate={[required()]} />
            <TextInput disabled source="id" label="Series Id" />
            <ReferenceInput
                label="Subchart"
                reference="portal/chartSubcharts"
                source="subchartId"
                style={{ width: "100%" }}
                sort={{ field: "subchart_order", order: "ASC" }}
            >
                <SelectInput optionText={(s) => s && s.order + ": " + s.name} validate={[required()]} />
            </ReferenceInput>
            <JsonEditor source="config" />
        </SimpleForm>
    </Edit>
);

export const ChartSeriesCreate = (props) => (
    <Create title={"New Chart Series"} {...props} transform={deleteEmptyKeys("config")}>
        <SimpleForm toolbar={<LVCreateToolbar />}>
            <TextInput source="name" validate={[required()]} />
            <TextInput source="alias" validate={[required()]} />
            <ReferenceInput
                label="Subchart"
                reference="portal/chartSubcharts"
                source="subchartId"
                style={{ width: "100%" }}
                sort={{ field: "subchart_order", order: "ASC" }}
            >
                <SelectInput optionText={(s) => s && s.order + ": " + s.name} validate={[required()]} />
            </ReferenceInput>
            <JsonEditor source="config" />
        </SimpleForm>
    </Create>
);
